import { createFileRoute } from "@tanstack/react-router";

import { ChangesPage } from "../../../areas/seller/changes/ChangesPage";
import type { ChangesSearch } from "../../../areas/seller/changes/search";

/** FE-08 change-request review queue (BE-12). */
export const Route = createFileRoute("/app/_seller/changes")({
  // Types the URL only; the lazy screen checks the values (parseChangesSearch), keeping the entry chunk lean.
  validateSearch: (search: Record<string, unknown>) => search as ChangesSearch,
  component: ChangesPage,
});
